export function setAuthorization (state, authorization) {
  state.authorization = authorization
}
